import { StyleSheet } from 'aphrodite';
import { charmGray } from '../../../../../web/styles/colors';

export const styleSheet = StyleSheet.create({
	container: {
		display: 'flex',
		flexDirection: 'column',
		gap: 20,
		padding: 20,
		alignItems: 'flex-start',
		justifyContent: 'flex-start',
	},
	subtitle: {
		fontSize: 16,
		fontWeight: 600,
	},
	periodsContainer: {
		display: 'flex',
		gap: 20,
		width: '100%',
		alignItems: 'center',
		justifyContent: 'space-around',
	},
	periodButton: {
		flexGrow: 1,
	},
	amountsContainer: {
		width: '100%',
		display: 'grid',
		gridTemplateColumns: 'repeat(2, 1fr)',
		gap: 12,

		'@media (min-width: 722px)': {
			gridTemplateColumns: 'repeat(4, 1fr)',
		},
	},

	amountButton: {},
	amountInput: {},
	coverFeesContainer: {
		display: 'flex',
		alignItems: 'flex-start',
		gap: 12,
	},
	coverFeesLabel: {
		fontSize: 12,
		fontWeight: 400,
		textAlign: 'start',
		color: charmGray,
	},
	addedFeeText: {
		fontSize: 12,
		fontWeight: 400,
		textAlign: 'start',
		color: charmGray,
		paddingTop: 8,
	},
	customAmountContainer: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'flex-start',
		gap: 8,
	},
});
